import { useState } from 'react';
import { toast } from 'sonner';
import { Trash2, LocateFixed, Play, MapPinPlus, Loader2, CloudDownload } from 'lucide-react';
import { routeStops, STOP_ICON } from '../lib/routeStops';

const n1 = (v) => (+v).toFixed(1).replace('.', ',');

// saved guide routes (from the LeakBuster): length, climb, stops along the way, go / delete
export default function PlanList({ t, project, updateProject, onLocate }) {
  const plans = project.plans || [];
  const [busy, setBusy] = useState(null);
  if (!plans.length) return null;
  const patch = (id, ch) => updateProject((p) => ({ ...p, plans: (p.plans || []).map((x) => (x.id === id ? { ...x, ...ch } : x)) }));
  const show = (pl) => window.dispatchEvent(new CustomEvent('giss-agent-route', { detail: { pts: pl.pts, name: pl.name, stops: pl.stops, keep: true } }));
  const findStops = async (pl) => {
    setBusy(pl.id);
    try {
      const stops = await routeStops(pl.pts, 1000);
      patch(pl.id, { stops });
      show({ ...pl, stops });
      toast.success(t.planStopsFound.replace('{n}', stops.length));
    } catch { toast.error(t.planStopsErr); }
    setBusy(null);
  };
  return (
    <div className="plan-list" data-testid="plan-list">
      <h4>{t.planListTitle}</h4>
      {plans.map((pl) => (
        <div key={pl.id} className="plan-item" data-testid={`plan-item-${pl.id}`}>
          <div className="plan-meta">
            <b>🗺 {pl.name}</b>
            <small data-testid={`plan-stats-${pl.id}`}>{pl.km != null ? `${n1(pl.km)} km` : ''} · ↑ {Math.round(pl.up || 0)} m · {pl.mode === 'foot' ? t.trkP_hike : t.trkP_road}{pl.t ? ` · ${new Date(pl.t).toLocaleDateString(t.locale)}` : ''}</small>
            {!!pl.stops?.length && <div className="plan-stops" data-testid={`plan-stops-${pl.id}`}>{pl.stops.map((s) => <span key={s.id}>{STOP_ICON[s.kind]} {s.name || t['planStop_' + s.kind]} <em>km {n1(s.at)}{s.off > 50 ? ` · ${s.off} m` : ''}</em></span>)}</div>}
          </div>
          <div className="plan-acts">
            <button type="button" className="icon-btn" data-testid={`plan-locate-${pl.id}`} title={t.locate} onClick={() => { show(pl); onLocate?.(pl.pts); }}><LocateFixed size={15} /></button>
            <button type="button" className="btn btn-outline btn-sm" data-testid={`plan-stops-btn-${pl.id}`} disabled={busy === pl.id} onClick={() => findStops(pl)}>{busy === pl.id ? <Loader2 size={13} className="spin" /> : <MapPinPlus size={13} />} {t.planStopsBtn}</button>
            <button type="button" className={`btn btn-sm ${pl.offlineAt ? 'btn-outline' : 'btn-dark'}`} data-testid={`plan-offline-${pl.id}`} title={pl.offlineAt ? `${t.planOfflineAt} ${new Date(pl.offlineAt).toLocaleDateString(t.locale)}` : ''} onClick={() => window.dispatchEvent(new CustomEvent('giss-cache-route', { detail: { id: pl.id, pts: pl.pts } }))}><CloudDownload size={13} /> {pl.offlineAt ? t.planOfflineOk : t.planOffline}</button>
            <button type="button" className="btn btn-green btn-sm" data-testid={`plan-go-${pl.id}`} onClick={() => window.dispatchEvent(new CustomEvent('giss-track-open', { detail: { ref: pl.id, profile: pl.mode === 'foot' ? 'hike' : 'road' } }))}><Play size={13} /> {t.planGo}</button>
            <button type="button" className="icon-btn danger" data-testid={`plan-delete-${pl.id}`} onClick={() => { if (window.confirm(t.planDelQ)) updateProject((p) => ({ ...p, plans: (p.plans || []).filter((x) => x.id !== pl.id) })); }}><Trash2 size={15} /></button>
          </div>
        </div>
      ))}
    </div>
  );
}
